module.exports = __webpack_public_path__ + "static/img/04.6df384a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/04.jpg
// module id = yCts
// module chunks = 0